import React from "react";

const NoDataFound = ({ data }) => {
  return (
    <div className="no-data">
      <h4>No {data} Found !</h4>
    </div>
  );
};

export default NoDataFound;
